<script>
import WarningCard from "@/components/_Shared/Warnings/Card";
import Notice from "@/components/_Shared/Notices/Content";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    WarningCard,
    Notice
  },

  computed: {
    ...mapState("user", ["user"]),
    ...mapGetters("user", ["hasNoVerifiedEmail", "answeredTermsOfUse"]),
    title() {
      return `Olá ${
        this.user.first_name
      }, notamos que você ainda não verificou seu e-mail.`;
    }
  },

  methods: {
    ...mapActions("user", ["showEmailNotVerifiedDialog"])
  }
};
</script>

<template>
  <div v-if="hasNoVerifiedEmail && answeredTermsOfUse">
    <notice
      icon="/static/mail.svg"
      :title="title"
      subtitle="Para criar um pedido o seu e-mail deve estar verificado."
    >
      <div class="btn bg-pink-outline mt-15" @click="showEmailNotVerifiedDialog()">verificar e-mail</div>
    </notice>
  </div>
</template>

<style scoped>
.div {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Warnings/EmailNotVerified/Notice.vue